export default __webpack_public_path__ + "static/media/Oracle-WindowsTaskScheduler-CreateBasicTaskWizard01.5207b755.png";